export default __webpack_public_path__ + "assets/media/birthday_cake.b4f57400.png";